export default __webpack_public_path__ + "static/media/watch2.83e04063.jpg";